export const MIN_STRING_LENGTH = 1;
export const MAX_CONTENT_PREVIEW_LENGTH = 1500;
export const MAX_AVTOR_LENGTH = 50;
export const MAX_TITLE_LENGTH = 300;
